import type { Theme } from '@mui/system';

export const styles = {
  select: {
    boxShadow: 'none',

    '& .MuiSelect-select': {
      backgroundColor: (theme: Theme) => theme.palette.baseColors.cloudGray.c25,
    },
  },

  textField: {
    backgroundColor: (theme: Theme) => theme.palette.baseColors.cloudGray.c25,
    '& .MuiOutlinedInput-root.Mui-focused': {
      '> .MuiOutlinedInput-notchedOutline': {
        borderColor: (theme: Theme) => theme.palette.baseColors.black.c100,
      },
    },
  },
};
